<ideal-file-button [url]="specSheetUrl()" label="Download Spec Sheet" i18n-label="@@ideal-product-download-spec-sheet-button.label" />
